import React, { useState } from "react";
import AtmCard from "../AtmCard";
import AtmCardForm from "../AtmCardForm";

export default function Billings() {
  const [showcardForm, setShowcardForm] = useState(false);
  const handleShowcardForm = () => setShowcardForm(!showcardForm);
  return (
    <>
      {showcardForm ? (
        <div className="adminCard p-5">
          <div className="clearfix profileArea" style={{ maxWidth: "400px" }}>
            <AtmCardForm handleShowcardForm={handleShowcardForm} />
          </div>
        </div>
      ) : (
        <div className="clearfix p-5">
          <div className="row no-gutters">
            <div className="clearfix px-3 mb30px">
              <AtmCard />
            </div>
            <div className="clearfix px-3 mb30px">
              <AtmCard />
            </div>
            <div className="clearfix px-3 mb30px">
              <AtmCard />
            </div>
            <div className="clearfix px-3 mb30px" onClick={handleShowcardForm}>
              <div className="atmcard atmcard_addnew">
                <span className="atmcard_plusbtn">+</span>
                <span className="atmcard_bankname">ADD NEW CARD</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
